<template>
  <el-dialog
      ref="singleTableRef"
      v-model="dialogVisible"
      :show-header="false"
      title="作品管理"
      top="120px"
      width="1000px"
      :close-on-click-modal="false"
      :append-to-body="true"
      :show-close="true"
      :before-close="handleClose">
    <div class="dialog-item ">
      <div class="d-flex align-items-center justify-content-around fw-bold  mb-2 bg-light ">
        <div class="my-2 fs-6 text-truncate text-center"  style="width: 30%;">阶段：{{props.stage==1?"初赛":"复赛"}}</div>
        <div class="my-2 fs-6 text-truncate text-center" style="width: 30%;">参赛组别：{{LevelName}}</div>
        <div class="my-2 fs-6 text-truncate text-center" style="width: 30%;">分组名称：{{Name}}</div>
      </div>
      <!--      搜索框-->
      <div class="d-flex align-items-center justify-content-between px-3 fw-bold  mb-2">
        <div>
          作品列表（{{listLen?listLen:0}}）
        </div>
        <el-button type="primary mx-2" :icon="Plus" @click="addWork()">添加</el-button>
      </div>
      <el-table
          :data="checkedList"
          border
          @row-click="handleTableCurrentChange"
          :current-row-key="currentRow"
          :highlight-current-row="true"
          style="width: 100%" height="500" v-loading="loading">
        <el-table-column type="index" width="70" label="序号"/>
        <el-table-column label="省份" >
          <template #default="scope">
            {{ scope.row.provinceName || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="阶段">
          <template #default="scope">
            {{ props.stage==1?"初赛":"复赛" }}
          </template>
        </el-table-column>
        <el-table-column label="参赛组别" width="120">
          <template #default="scope">
            {{ scope.row.LevelName || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="参赛大学">
          <template #default="scope">
            {{ scope.row.SchoolName || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="参赛名称">
          <template #default="scope">
            {{ scope.row.TeamName || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="选题类型">
          <template #default="scope">
            {{ scope.row.TopicName || "" }}
          </template>
        </el-table-column>
        <el-table-column label="参赛作品" width="200">
          <template #default="scope">
            {{ scope.row.Name || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template #default="scope">
            <el-button  size="small" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
<!--    <template #footer>-->
<!--      <span class="dialog-footer">-->
<!--        <el-button @click="handleClose">取消</el-button>-->
<!--        <el-button type="primary" @click="save(ruleFormRef)"-->
<!--                   :loading = "loading"-->
<!--        >确定</el-button-->
<!--        >-->
<!--      </span>-->
<!--    </template>-->

  </el-dialog>
<!-- 第二个模态框-->
  <el-dialog
      ref="singleTableRef1"
      v-model="dialogVisible1"
      :show-header="false"
      title="作品管理"
      top="20px"
      width="1000px"
      :close-on-click-modal="false"
      :append-to-body="true"
      :show-close="true"
      :before-close="handleClose1">
    <div class="dialog-item1 ">
      <!--      搜索框-->
      <el-form :model="queryParam" label-width="auto" style="max-width: 400px" @submit.native.prevent>
        <div class="d-flex">
          <el-form-item label="作品名称："  class="me-3">
            <el-input style="width: 200px"  v-model="queryParam.keyword" placeholder="请输入学校名称" clearable @clear="getList(true)"/>
          </el-form-item>
          <el-form-item label="选题类型："  class="me-3">
            <!--          <el-input v-model="params.name" style="width: 100px" clearable/>-->
            <el-select v-model="queryParam.topic_id" style="width: 200px" clearable >
              <el-option v-for="i of topics" :key="i.ID" :value="i.ID" :label="i.Name" />
            </el-select>
          </el-form-item>
          <el-form-item label="所属大学："  class="me-3">
            <!--          <el-input v-model="params.name" style="width: 100px" clearable/>-->
            <el-select v-model="queryParam.university_id" style="width: 200px" clearable filterable>
              <el-option v-for="i of schools" :key="i.ID" :value="i.ID" :label="i.Name" />
            </el-select>
          </el-form-item>
          <el-button type=" mx-2" :icon="Search" @click="getList(true)">搜索</el-button>
        </div>
      </el-form>
      <el-table
          :data="allWorkList"
          border
          @row-click="handleTableCurrentChange"
          :current-row-key="currentRow"
          :highlight-current-row="true"
          @selection-change="handleSelectionChange"
          style="width: 100%" height="500" v-loading="loading">
        <el-table-column type="selection" width="55" />
        <el-table-column label="参赛组别" width="120" show-overflow-tooltip>
          <template #default="scope">
            {{ scope.row.LevelName || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="参赛大学" show-overflow-tooltip>
          <template #default="scope">
            {{ scope.row.SchoolName || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="参赛名称" show-overflow-tooltip>
          <template #default="scope">
            {{ scope.row.TeamName || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="选题类型" show-overflow-tooltip>
          <template #default="scope">
            {{ scope.row.TopicName || "" }}
          </template>
        </el-table-column>
        <el-table-column label="参赛作品" width="100" show-overflow-tooltip>
          <template #default="scope">
            {{ scope.row.Name || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="初赛分组" width="85" show-overflow-tooltip>
          <template #default="scope">
           <text style="color: #3f9dfd" v-if="scope.row.WorkgroupIdPre && scope.row.WorkgroupIdPre>0 ">已分组</text>
            <text style="color: red" v-else>未分组</text>
          </template>
        </el-table-column>
        <el-table-column label="复赛分组" width="85" show-overflow-tooltip>
          <template #default="scope">
            <text style="color: #3f9dfd" v-if="scope.row.WorkgroupIdFinal && scope.row.WorkgroupIdFinal>0 ">已分组</text>
            <text style="color: red" v-else>未分组</text>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <template #footer>
      <span class="d-flex align-items-center justify-content-center mb-5">
       <el-pagination v-show="total>0"
                      layout="total, prev, pager, next"
                      :page-sizes="[10, 20, 30, 40]"
                      :total="total"
                      v-model:current-page="queryParam.current"
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"/>
      </span>
      <span class="dialog-footer">
        <el-button @click="handleClose1">关闭</el-button>
        <el-button type="primary" @click="addToGroup(ruleFormRef)"
                   :loading = "addLoading"
        >添加</el-button
        >
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import {ref, defineProps, defineEmits, onMounted, reactive} from 'vue';
import {getSchoolList} from "@/api/school";
import {Search,Plus} from '@element-plus/icons-vue'
const currentRow = ref()
const singleTableRef = ref()
const emits = defineEmits(['close', 'choised'])
const dialogVisible = ref(true)
const dialogVisible1 = ref(false)
import {ElMessage, ElMessageBox} from "element-plus";
import {addWorkToWorkgroup, getWorkgroupDetail, removeWorkFromWorkgroup} from "@/api/workgroupAdmin";
import {getTopics} from "@/api/topicAdmin";
import {getWorks} from "@/api/entryAdmin";
import {getName} from "@/utils/commonSetting";
const LEVELS = [
  {ID:1,Name:"专科组"},
  {ID:2,Name:"本科生组"},
  {ID:3,Name:"研究生组"},
  {ID:4,Name:"所有分组"},
]
import {formatTime} from "@/utils/dateFun";
import {removeTeacher} from "@/api/student";
const listLen = ref(0)
const list = ref([])
const allWorkList =ref([]) // 所有作品
const loading = ref(false)
const total = ref(10)
const topics = ref([]) // 选题
const schools = ref([]) // 学校列表
const multipleSelection = ref([]) // 被选中的
const addLoading = ref(false) // 需要添加的内容
const Name = ref("")
const LevelName = ref("")
const queryParam = reactive({
  pageSize: 10,
  current: 1,
  keyword: "",
  topic_id:"",
  university_id:"",
  province:"", // 省份 这里是赛区对应的省份，支持多个，即用英文逗号分隔的多个省份,从分组详情获取
  level:"",//组别,从分组详情获取
  year:new Date().getFullYear(),//自动获取当年
  exludeWorkgroup:"", // 分组id
})
const checkedList = ref([])
const props = defineProps({
  item: {
    default: {},
  },
  stage:{
    default:null
  }
})
// 开始
onMounted(() => {
  if(props.item){ // 设置
    LevelName.value =getName(LEVELS,props.item.Level)
    Name.value = props.item.Name
    if(props.item && props.item.Zone && props.item.Zone.Provinces){
      queryParam.province = props.item.Zone.Provinces // 分组赛区
    }
    if(props.item && props.item.Level ){
      queryParam.level = props.item.Level // 设置组别
      if(queryParam.level===4){
        queryParam.level = ""
      }
    }
    queryParam.exludeWorkgroup = props.item.ID
  }
  getDetail()
  getTopicList()// 获取选题
  getSchoolAll()
  // addWork()//
})

const handleCurrentChange = () => {
  getList()
}

// 获取详情
const getDetail = async ()=>{
  try {
    const detail = await getWorkgroupDetail({id:props.item.ID}) //props.item.ID // 获取详情
    checkedList.value = []
    if(detail.err_code === 0 && detail.data && detail.data.Works){
     const data =  detail.data.Works || []
      data.forEach(item=>{
        if(item.Level){
          item.LevelName = getName(LEVELS,item.Level)
        }
        if(item.Topic){
          item.TopicName = item.Topic.Name
        }
        if(item.Team){
          item.TeamName = item.Team.Name
          item.TeamContact = item.Team.Contact
          item.TeamPhone = item.Team.Phone
          item.TeamName = item.Team.Name
          if(item.Team.University){
            item.SchoolName = item.Team.University.Name
            item.provinceName = item.Team.University.Province
          }
        }
      })
      checkedList.value = data
      listLen.value = data.length
    }

  }catch (err){
    return ElMessage.success("无法获取信息")
  }
}
// 获取选题
const getTopicList = async ()=>{
  const res = await getTopics()
  if(res.success){
    topics.value = res.data || []
  }

}
// 获取所有学校
const getSchoolAll = async ()=>{
  const res = await getSchoolList({pageSize:10000,current:1})
  if(res.success){
    schools.value = res.data || []
  }
}
// 表行被选择
const handleTableCurrentChange = (val) => {
  currentRow.value = val
}
// 被选中的
const handleSelectionChange = (val) => {
  multipleSelection.value = val
}

// 删除
const handleDelete = (number,item)=>{
  ElMessageBox.alert('确定要删除吗？', '删除', {
    confirmButtonText: '确定',
    callback: (action) => {
      if(action==='confirm'){ // 确定
        // const needInitQuery = needInitQueryFun(total.value,queryParam.pageSize,number)
        removeWorkFromWorkgroup({WorkgroupId: props.item.ID,WorkIds :[item.ID]}).then(res=>{
          if(res.err_code === 0){
            ElMessage.success(`删除成功`)
            getDetail()
          }else{
            ElMessage.error(res.err_msg ||`删除失败,请稍后再试`)
          }
        })
      }
    },
  })
}
// 打开添加作品模态框
const addWork = async ()=>{
  dialogVisible1.value = true
  addLoading.value = false
  getList(true)
}
// 添加至组内
const addToGroup = async ()=>{
  if(!multipleSelection.value|| multipleSelection.value.length<=0){
    return ElMessage.warning("请至少选择一个作品")
  }
  const WorkIds = multipleSelection.value.map(item=>item.ID)
  addLoading.value = true
  const res = await addWorkToWorkgroup({WorkgroupId: props.item.ID,WorkIds:WorkIds})
  addLoading.value = false
  if(res && res.err_code===0){
     ElMessage.success("添加成功")
     getList(true) // 重新获取列表
     getDetail() // 重新获取列表
  }else{
    return ElMessage.error("添加失败")
  }
}
// 页码改变
const handleSizeChange = (event) => {
  if (queryParam.pageSize !== event) {
    queryParam.current = 1
    queryParam.pageSize = event
    getList()
  }
}
// 获取所有列表
const getList =  async (init) => {
  if(init){
    queryParam.current = 1
  }
  loading.value = true
  const res = await getWorks(queryParam)
  loading.value = false
  if(res.success){
    let data = res.data || []
    data.forEach(item=>{
      if(item.Level){
        item.LevelName = getName(LEVELS,item.Level)
      }
      if(item.Topic){
        item.TopicName = item.Topic.Name
      }
      if(item.Team){
        item.TeamName = item.Team.Name
        item.TeamContact = item.Team.Contact
        item.TeamPhone = item.Team.Phone
        item.TeamName = item.Team.Name
        if(item.Team.University){
          item.SchoolName = item.Team.University.Name
        }
      }
    })
    total.value = res.total
    allWorkList.value = data
  }else{
    ElMessage.warning("请求失败")
  }
}
const handleClose = ()=>{
  dialogVisible.value = false
  emits("close", true)
}
const handleClose1 = () => {
  dialogVisible1.value = false

}




</script>

<style scoped lang="scss">
.dialog-item1 {
  width: 100%;
  height: 450px;
  overflow-x: hidden;
  overflow-y: auto;
}

.dialog-item {
  width: 100%;
  height: 650px;
  overflow-x: hidden;
  overflow-y: auto;
}
:deep(.el-table) .table-selected-row{
  --el-table-tr-bg-color: red;
}


</style>
